export default __webpack_public_path__ + "static/media/p1.827f3cb4.jpg";